import React, { useEffect, useState } from 'react';
import './index.scss'
import { Button } from 'antd';
import { envConfig } from '@/config/common';

function Header({ title = '' }) {
  const keyMap = {
    '#/website/invest': '招商首页',
    '#/website/settle-in': '入驻流程',
    '#/website/qualification': '资质要求',
    '#/website/questions': '常见问题'
  }
  const [hash, setHash] = useState(location.hash)


  const [activeKey, setActiveKey] = useState<string>(hash)

  const handleNavClick = (key: string) => () => {
    console.log(key)
    setActiveKey(key)
    const prefix = location.protocol + '//' + envConfig.SERVICE_MAIN_DOMAIN
    location.href = prefix + key
  }
  const handleHashChange = (e) => {
    if (e.newURL != e.oldURL) {
      setActiveKey(location.hash)
    }
  }

  const handleLogin = () => {
    const prefix = location.protocol + '//' + envConfig.SERVICE_SECOND_DOMAIN
    location.href = prefix + '#/sys/login'
  }
  const handleIndex = () => {
    const prefix = location.protocol + '//' + envConfig.SERVICE_MAIN_DOMAIN
    location.href = prefix + '#/website/invest'
  }

  useEffect(() => {
    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <>
      <div className='header-container'>
        <div className='header-left'>
          <div className='logo' onClick={handleIndex}>
          </div>
          <div className='title'>
            <span className='title-text'>{title}</span>
          </div>
        </div>
        <div className="header-nav">
          {
            Object.keys(keyMap).map(key => (
              <div
                key={key}
                className={`nav-item ${activeKey === key ? 'active' : ''}`}
                onClick={handleNavClick(key)}
              >
                {keyMap[key]}
              </div>
            ))
          }
        </div>
        <div className='header-right'>
          <div className="contact">
            {/*<div className="title">加盟合作咨询</div>*/}
            {/*<div className="contact-number">{variable.CONTACT_NUMBER}</div>*/}
          </div>
          <Button type="primary" ghost onClick={handleLogin}>登录</Button>
        </div>

      </div>
    </>
  );
}


export default Header;
